import React from 'react'
import { observer } from 'mobx-react'
import api from 'api'
import dynamic from 'next/dynamic'
import getConfig from 'next/config'
import * as R from 'ramda'
import { COUPON_PLATFORM } from 'constants/coupon'

const SkuDetailContents = {
  app01webview: dynamic(() => import('/components/SkuDetail')),
  generalWeb: dynamic(() => import('/components/SkuDetailV2')),
}
const skuPlatform = {
  app01webview: COUPON_PLATFORM.HK01_APP,
  generalWeb: COUPON_PLATFORM.COUPON_WEB,
}
const Sku = observer((props) => {
  const { publicRuntimeConfig } = getConfig()
  const SkuDetail = SkuDetailContents[publicRuntimeConfig.SERVICE_SEGMENT]
  return <SkuDetail {...props} />
})

const getSkuDetailData = async (skuIdOrHashId) => {
  let result = {}
  const { publicRuntimeConfig } = getConfig()
  try {
    result = await api.getSku(skuIdOrHashId, {
      platform: skuPlatform[publicRuntimeConfig.SERVICE_SEGMENT],
    })
  } catch (err) {
    result = R.path(['response', 'data', 'error'], err)
  }
  const { data: sku, code: errCode } = result
  return {
    sku,
    error: errCode ? result : null,
  }
}

Sku.getInitialProps = async (props) => {
  const {
    pathname,
    query,
    asPath,
    req: { featureFlags },
  } = props
  const { id: skuIdOrHashId = '', fast: fastShare } = query
  const defaultResponse = {
    skuIdOrHashId,
    asPath,
    pathname,
    query,
    isFullPage: true,
    fastShare,
  }

  if (
    skuIdOrHashId.startsWith(' ') ||
    (/^\d+$/.test(skuIdOrHashId) && !featureFlags.accessBySkuId)
  ) {
    return {
      ...defaultResponse,
      error: {
        code: '10111',
      },
    }
  }

  const { sku, error } = await getSkuDetailData(skuIdOrHashId)
  return {
    ...defaultResponse,
    sku,
    error,
  }
}

export default Sku
